// @ts-ignore
import base64UTF8 from 'base64-utf8-transfer';

export default (username: string, password: string): string =>
  `Basic ${base64UTF8.encode(`${username}:${password}`)}`;

export const generateNewAuthString = (
  oldAuthResult: string,
  oldUsername: string,
  newUsername: string
): string | null => {
  if (!oldAuthResult || !oldUsername) {
    return null;
  }
  try {
    const base64Encoded = oldAuthResult?.replace('Basic ', '');
    const decodedString = base64UTF8?.decode(base64Encoded);
    const parts = decodedString?.split(':');
    if (!parts || parts.length !== 2 || parts[0] !== oldUsername) {
      return null;
    }
    const extractedPassword = parts[1];

    return `Basic ${base64UTF8.encode(`${newUsername}:${extractedPassword}`)}`;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
};

export const updatePasswordInAuthString = (
  oldAuthResult: string,
  newPassword: string
): string | null => {
  if (!oldAuthResult || !newPassword) {
    return null;
  }
  try {
    const base64Encoded = oldAuthResult?.replace('Basic ', '');
    const decodedString = base64UTF8?.decode(base64Encoded);
    const parts = decodedString?.split(':');

    if (!parts || parts.length !== 2) {
      return null;
    }

    const extractedEmail = parts[0];

    return `Basic ${base64UTF8.encode(`${extractedEmail}:${newPassword}`)}`;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
};
